import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Model, Response} from '../models/models';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModelService {

  constructor(private httpClient: HttpClient) { }

  getModels(): Observable<Response<Model[]>> {
    return this.httpClient.get<Response<Model[]>>(environment.apiPath + 'Model');
  }
}
